<template>
  <div class="page article__page">
    <html-viewer class="page__bd" v-if="article.contentHtml" :content="article.contentHtml" />
  </div>
</template>

<script>
import HtmlViewer from "@/components/HtmlViewer.vue";

export default {
  props: {
    projectCode: String,
    itemCode: String
  },
  components: {
    HtmlViewer
  },
  data() {
    return {
      article: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getArticle();
    });
  },
  methods: {
    getArticle() {
      var me = this;
      me.$ajax({
        url: "/api/help/article/read",
        params: {
          projectCode: me.projectCode,
          itemCode: me.itemCode
        }
      }).then(function(res) {
        if (res.success) {
          me.article = res.data || {};
          if (res.data) {
            document.title = res.data.itemName;
          }
        }
      });
    }
  }
};
</script>

<style>
.article__page {
  background: #fff;
}
</style>